import React from 'react';
import { fmtDim, statusColor, computeSidemark, estimatedShipDate, canonicalItemStatus, itemFeeBreakdown } from '../utils';

export default function TearSheet(p){
  var f=p.item||{};
  var specs=f.specs||{};
  var fees=f.fees||{};
  var isClient=p.mode==="client";
  var isOwner=p.isOwner||false;
  // Resolve ship-to address for internal view
  var sp=null;for(var _pi=0;_pi<(p.projects||[]).length;_pi++){if((p.projects[_pi].label||p.projects[_pi].id)===f.project||(p.projects[_pi].label===f.project)){sp=p.projects[_pi];break;}}
  var receiver=null;if(sp&&sp.receiverId)(p.vendors||[]).forEach(function(v){if(v.id===sp.receiverId||String(v.id)===String(sp.receiverId))receiver=v;});
  function fmtAddr(v){if(!v)return null;var lines=[v.address,v.address2,[v.city,v.state,v.zip].filter(Boolean).join(", ")].filter(Boolean);return lines.length?lines.join(", "):null;}
  // Ship-to: item-level vendor picker first; else project receiver
  var shipToVdr=null;if(f.shipToVendorId)(p.vendors||[]).forEach(function(v){if(String(v.id)===String(f.shipToVendorId))shipToVdr=v;});
  var itemShipTo=shipToVdr?(shipToVdr.name||"")+(fmtAddr(shipToVdr)?" · "+fmtAddr(shipToVdr):""):fmtAddr(receiver)?(receiver.name||"")+(receiver.name?" · ":"")+fmtAddr(receiver):null;
  function fmtAddrML(v){if(!v)return null;var lines=[v.address,v.address2,[v.city,v.state,v.zip].filter(Boolean).join(' ')].filter(Boolean);return lines.length?lines.join('\n'):null;}
  var itemShipToML=shipToVdr?[shipToVdr.name,fmtAddrML(shipToVdr)].filter(Boolean).join('\n'):receiver?[receiver.name,fmtAddrML(receiver)].filter(Boolean).join('\n'):null;
  var markupPct=parseFloat(f.markupPct||30);
  var MARKUP=1+(markupPct/100);
  var netCost=parseFloat(f.netPrice||0);
  var qty=parseFloat(f.qty||1);
  var clientPrice=netCost*MARKUP;
  // Tolerant of NUMBER values (items.fees stores numbers as of Phase 5,
  // 2026-06-27). String() wrap before .replace() prevents
  // "replace is not a function" on numeric inputs.
  function feeN(s){var n=parseFloat(String(s==null?"":s).replace(/[$,]/g,""));return isNaN(n)?0:n;}
  // Fee math comes from itemFeeBreakdown — the same helper the invoice
  // builders and Reconciliation use — so the tear sheet can never
  // disagree with what the client is billed. Before 2026-10-06 this file
  // carried its own 1.10 constant and applied it to every fee including
  // custom rows, so a custom fee at 15% printed "+10%" and a wrong total.
  var fb=itemFeeBreakdown(f);
  function pctLabel(cost,client){if(cost<=0)return"";var pct=Math.round(((client/cost)-1)*1000)/10;return" (+"+pct+"%)";}
  var feeTotal=fb.totals.client;
  var lineTotal=clientPrice*qty+feeTotal;

  var feeLines=[];
  [["freight","Freight"],["crating","Crating"],["installation","Installation"],["salesTax","Sales Tax"],["tariff","Tariff"]].forEach(function(pair){
    var b=fb.byCategory[pair[0]];if(b&&b.client>0)feeLines.push({l:pair[1],a:b.client});
  });
  fb.custom.forEach(function(c){feeLines.push({l:c.label||"Fee",a:c.client});});

  var comKids=(f.children||[]).filter(function(c){return c.childType==="COM/COL Fabric";});
  var comSummary=comKids.map(function(c){var com=c.com||{};return[com.patternColorway,com.manufacturer].filter(Boolean).join(" · ");}).filter(Boolean).join("; ");

  function fmt(n){
    if(n===null||n===undefined||n==="")return"—";
    var num=parseFloat(String(n).replace(/[$,]/g,""));
    if(isNaN(num))return"—";
    return"$"+num.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2});
  }

  var specRows=[
    (f.manufacturer||specs.manufacturer)&&{l:"Manufacturer",v:f.manufacturer||specs.manufacturer},
    (f.model||specs.model)&&{l:"Model",v:f.model||specs.model},
    (f.dimensions||specs.dimensions)&&{l:"Dimensions",v:fmtDim(f.dimensions||specs.dimensions)},
    (f.finish||specs.finish)&&{l:"Finish",v:f.finish||specs.finish},
    f.leadTime&&{l:"Lead Time",v:f.leadTime},
    f.qty&&f.qty!=="1"&&{l:"Qty",v:f.qty+(f.qtyType?" "+f.qtyType:"")},
    comSummary&&{l:"COM / COL",v:comSummary,full:true},
    !isClient&&(f.specNotes||specs.description)&&{l:"Notes",v:f.specNotes||specs.description,full:true},
  ].filter(Boolean);

  var S={
    wrap:{background:"#fff",border:"0.5px solid #E0E0DC",borderRadius:10,overflow:"hidden",fontSize:12},
    hdr:{padding:"10px 14px",borderBottom:"0.5px solid #E0E0DC",display:"flex",justifyContent:"space-between",alignItems:"flex-start"},
    firm:{fontSize:10,fontWeight:600,letterSpacing:2,textTransform:"uppercase",color:"#111"},
    tag:{fontSize:9,color:"#999",marginTop:2,fontFamily:"monospace"},
    sm:{fontSize:9,color:"#999",fontWeight:600,marginTop:2},
    imgBox:{width:"100%",aspectRatio:"4/3",background:"#f9f9f9",borderBottom:"0.5px solid #E0E0DC",display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden"},
    body:{padding:"12px 14px"},
    name:{fontSize:14,fontWeight:600,color:"#111",marginBottom:2},
    vendor:{fontSize:11,color:"#888",marginBottom:10},
    specGrid:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px 14px",marginBottom:10},
    specLabel:{fontSize:9,fontWeight:600,color:"#999",textTransform:"uppercase",letterSpacing:0.5,marginBottom:1},
    specVal:{fontSize:11,color:"#111"},
    divider:{border:"none",borderTop:"0.5px solid #E0E0DC",margin:"8px 0"},
    footer:{padding:"8px 14px",background:"#f9f9f9",borderTop:"0.5px solid #E0E0DC",display:"flex",justifyContent:"space-between",alignItems:"center"},
    statusBadge:{fontSize:9,fontWeight:600,padding:"2px 8px",borderRadius:10},
  };

  var status=f.status||"Specifying";
  var imgs=f.images||[];
  var heroIdx=f.heroIndex||0;
  var heroImg=imgs.length>0?imgs[Math.min(heroIdx,imgs.length-1)]:null;
  var imgSrc=heroImg?heroImg.url:(f.imageData||f.imageUrl||"");
  var sidemark=computeSidemark(f.project,f.roomName,f.roomNumber);

  return <div style={S.wrap}>
    <div style={S.hdr}>
      <div>
        <div style={S.firm}>Cimon Starr</div>
        {(specs.tag||sidemark)&&<div style={S.tag}>{specs.tag||(f.roomNumber?" #"+f.roomNumber:"")}</div>}
        {(!isClient&&f.importSource)?<div style={{fontSize:9,background:"#fff3e0",color:"#e65100",fontWeight:600,padding:"1px 6px",borderRadius:4,marginTop:3,display:"inline-block"}}>{f.importSource+(f.importDate?" · "+f.importDate:"")}</div>:null}
      </div>
      <div style={{textAlign:"right"}}>
        <span style={Object.assign({},S.statusBadge,{background:statusColor(status),color:"#fff"})}>{status}</span>
        {(f.roomName||f.project)&&<div style={{fontSize:9,color:"#999",marginTop:4}}>
          {[f.roomName,f.project].filter(Boolean).join(" · ")}
        </div>}
      </div>
    </div>

    <div style={S.imgBox}>
      {imgSrc?
        <img src={imgSrc} alt={f.item||""} style={{width:"100%",height:"100%",objectFit:"cover"}} onError={function(e){e.target.style.display="none";}} />:
        <div style={{textAlign:"center",color:"#999"}}>
          <div style={{fontSize:20,marginBottom:4}}>📷</div>
          <div style={{fontSize:10}}>No image uploaded</div>
        </div>}
    </div>
    {imgs.length>1&&<div style={{display:"flex",gap:3,padding:"6px 8px",background:"#f9f9f9",borderBottom:"0.5px solid #E0E0DC",overflowX:"auto"}}>
      {imgs.map(function(img,i){
        return <img key={i} src={img.url} alt={img.label||""} onClick={function(){}}
          style={{width:40,height:40,objectFit:"cover",borderRadius:4,flexShrink:0,
            border:i===(f.heroIndex||0)?"2px solid #1a1a1a":"1px solid #e0e0e0",
            cursor:"default",opacity:i===(f.heroIndex||0)?1:0.7}} />;
      })}
    </div>}

    <div style={S.body}>
      {isClient
      ?<div>
        <div style={S.name}>{f.productName||f.item||"Item name"}</div>
        <div style={S.vendor}>{f.vendor||"—"}</div>
        <div style={S.specGrid}>
          {specRows.map(function(sr,i){
            return <div key={i} style={sr.full?{gridColumn:"1/-1"}:{}}>
              <div style={S.specLabel}>{sr.l}</div>
              <div style={S.specVal}>{sr.v}</div>
            </div>;
          })}
        </div>
        <hr style={S.divider} />
        <div style={{marginBottom:10}}>
          <div style={S.specLabel}>Tracking</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:"6px 16px",marginTop:4}}>
            <div>
              <div style={S.specLabel}>Status</div>
              <div style={{fontSize:11,fontWeight:600,color:statusColor(status)}}>{status}</div>
            </div>
            {f.leadTime&&<div>
              <div style={S.specLabel}>Lead time</div>
              <div style={{fontSize:11,display:"flex",alignItems:"center",gap:4}}>{f.leadTime}{f.leadWeeks&&<span style={{color:"#888",fontSize:11}}>({f.leadWeeks} wks)</span>}</div>
            </div>}
            {(f.orderPlacedDate||["At Receiver","Delivered","Installed"].indexOf(canonicalItemStatus(f.status))>=0)?
              <div>
                <div style={S.specLabel}>Ordered</div>
                <div style={{fontSize:11,color:"#111",fontWeight:500}}>{f.orderPlacedDate||"Yes"}</div>
              </div>:
              <div>
                <div style={S.specLabel}>Ordered</div>
                <div style={{fontSize:11,color:"#888"}}>Not yet ordered</div>
              </div>}
            {f.leadTime&&f.orderPlacedDate&&<div>
              <div style={S.specLabel}>Est. delivery</div>
              <div style={{fontSize:11,color:"#0277bd",fontWeight:500}}>
                {(function(){
                  // Routes through canonical estimatedShipDate helper
                  // (utils.js). Helper returns local-date components
                  // ("2026-04-26" = local Apr 26). Parse with explicit
                  // T00:00:00 so the date constructor treats it as
                  // local midnight (NOT UTC midnight which would shift
                  // back to previous-day evening in PST/PDT). This
                  // matches the helper's local-calendar semantic and
                  // displays the correct day.
                  var iso = estimatedShipDate(f);
                  if (!iso) return "See lead time";
                  try {
                    var d = new Date(iso + "T00:00:00");
                    if (isNaN(d.getTime())) return "See lead time";
                    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
                  } catch (e) { return "See lead time"; }
                })()}
              </div>
            </div>}
            {f.receivedDate&&<div>
              <div style={S.specLabel}>Received</div>
              <div style={{fontSize:11,color:"#2e7d32",fontWeight:600}}>{"✓ "+f.receivedDate}</div>
            </div>}
          </div>
        </div>
        <hr style={S.divider} />
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end"}}>
          <div>
            <div>
              <div style={S.specLabel}>Client price</div>
              <div style={{fontSize:13,fontWeight:600,color:"#111"}}>
                {fmt(clientPrice)}
                {qty>1&&<span style={{fontSize:10,color:"#888",marginLeft:4}}>{"× "+qty+" = "+fmt(clientPrice*qty)}</span>}
              </div>
              {feeLines.map(function(fl,i){return <div key={i} style={{fontSize:10,color:"#555",marginTop:1}}>{"+ "+fl.l+": "+fmt(fl.a)}</div>;})}
              {feeTotal>0&&<div style={{fontSize:11,fontWeight:600,color:"#111",marginTop:4}}>{"Total: "+fmt(lineTotal)}</div>}
            </div>
          </div>
          <div style={{textAlign:"right"}}>
            {f.proposalRef&&<div>
              <div style={S.specLabel}>Proposal</div>
              <div style={{fontSize:11}}>{f.proposalRef}</div>
            </div>}
            {f.poNumber&&<div style={{marginTop:4}}>
              <div style={S.specLabel}>PO</div>
              <div style={{fontSize:11}}>{f.poNumber}</div>
            </div>}
          </div>
        </div>
      </div>
      :<div>
        {(function(){
          var LR={display:"flex",alignItems:"baseline",gap:6,padding:"5px 0",borderBottom:"0.5px solid #f0f0f0",textAlign:"left"};
          var LL={fontSize:11,fontWeight:600,color:"#888",width:120,flexShrink:0,textAlign:"left"};
          var LV={fontSize:12,color:"#1a1a1a",textAlign:"left",wordBreak:"break-word"};
          var dp=parseFloat(f.depositPct||50);
          // dp>=100: all fees collected at deposit; otherwise fees go to final invoice
          var rows=[
            {l:"Product",v:f.productName||f.item||null},
            {l:"Manufacturer",v:f.manufacturer||specs.manufacturer||null},
            {l:"Vendor",v:f.vendor||null},
            {l:"Model",v:f.model||specs.model||null},
            {l:"Finish",v:f.finish||specs.finish||null},
            {l:"Dimensions",v:(f.dimensions||specs.dimensions)?fmtDim(f.dimensions||specs.dimensions):null},
            {l:"Qty",v:f.qty&&f.qty!=="0"?f.qty+(f.qtyType?" "+f.qtyType:""):null,skipBlank:true},
            {l:"Date Added",v:f.date||null,skipBlank:true},
            {l:"Lead Time",v:f.leadTime||null},
            {l:"Ships to",v:itemShipToML||null,ml:true},
            {l:"Source URL",v:f.sourceUrl||null,href:f.sourceUrl||null,skipBlank:true},
            {l:"Net Cost per Item",v:netCost>0?fmt(netCost):null},
            {l:"Markup",v:netCost>0?(markupPct+"%"):null},
            {l:"Client Price per Item",v:netCost>0?fmt(clientPrice):null},
            {l:"Client Product Total",v:netCost>0?fmt(clientPrice*qty)+(qty>1?"  ×"+qty:""):null},
            {l:"Vendor Deposit per Item",v:netCost>0?fmt(netCost*(dp/100))+" ("+dp+"%)":null},
            {l:"Vendor Deposit Total",v:netCost>0?fmt(netCost*qty*(dp/100))+(qty>1?" ×"+qty:""):null},
            {l:"Tearsheet Date",v:new Date().toLocaleDateString()},
          ];
          // COM children ship-to addresses — use vendor picker first, fall back to free-text
          comKids.forEach(function(c){
            var comShip="";
            if(c.shipToVendorId){
              var stv=null;(p.vendors||[]).forEach(function(v){if(String(v.id)===String(c.shipToVendorId))stv=v;});
              if(stv){var lines=[stv.name,stv.address,stv.address2,[stv.city,stv.state,stv.zip].filter(Boolean).join(' ')].filter(Boolean);comShip=lines.join('\n');}
            }
            if(!comShip){var com=c.com||{};comShip=[com.shipToName,com.shipToAddress,[com.shipToCity,com.shipToState,com.shipToZip].filter(Boolean).join(", ")].filter(Boolean).join(", ");}
            if(comShip)rows.push({l:"COM ships to",v:comShip,ml:true});
          });
          // Fees from itemFeeBreakdown: each line prints the rate it actually
          // bills at; sales tax and tariff are pass-through (no markup).
          var totalFeeNet=fb.totals.cost,totalFeeClient=fb.totals.client;
          [["freight","Freight"],["crating","Crating"],["installation","Installation"]].forEach(function(pair){
            var b=fb.byCategory[pair[0]];if(b&&b.cost>0)rows.push({l:pair[1],v:fmt(b.cost)+" net · "+fmt(b.client)+" billed"+pctLabel(b.cost,b.client)});
          });
          [["salesTax","Sales Tax"],["tariff","Tariff"]].forEach(function(pair){
            var b=fb.byCategory[pair[0]];if(b&&b.cost>0)rows.push({l:pair[1],v:fmt(b.cost)+" (no markup)"});
          });
          fb.custom.forEach(function(c){rows.push({l:c.label||"Fee",v:fmt(c.cost)+" net · "+fmt(c.client)+" billed"+pctLabel(c.cost,c.client)});});
          if(netCost>0||totalFeeNet>0){
            rows.push({l:"Total Net Cost",v:fmt(netCost*qty+totalFeeNet)});
            rows.push({l:"Total Client Price",v:fmt(clientPrice*qty+totalFeeClient)});
          }
          if(netCost>0){
            var _depAmt=dp>=100?fmt(clientPrice*qty+totalFeeClient):fmt(clientPrice*qty*0.80);
            rows.push({l:"Client Deposit Requested ("+(dp>=100?"100%":"80%")+")",v:_depAmt+" ("+(dp>=100?"100":"80")+"%)"});
          }
          return rows.map(function(r,i){if(!r.v){if(r.skipBlank)return null;r=Object.assign({},r,{v:"—",href:null});}return r;}).filter(Boolean).map(function(r,i){
            return <div key={i} style={LR}>
              <div style={LL}>{r.l}</div>
              {r.href
                ?<a style={Object.assign({},LV,{color:"#1a56db",textDecoration:"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:200})} href={r.href} target="_blank" rel="noopener noreferrer">{r.v}</a>
                :<div style={r.ml?Object.assign({},LV,{whiteSpace:"pre-line",lineHeight:1.6}):LV}>{r.v}</div>}
            </div>;
          });
        })()}
        <hr style={S.divider} />
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
          <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
            <div>
              <div style={S.specLabel}>Status</div>
              <div style={{fontSize:11,fontWeight:600,color:statusColor(status)}}>{status}</div>
            </div>
            {f.orderPlacedDate&&<div>
              <div style={S.specLabel}>Ordered</div>
              <div style={{fontSize:11,color:"#111",fontWeight:500}}>{f.orderPlacedDate}</div>
            </div>}
            {f.receivedDate&&<div>
              <div style={S.specLabel}>Received</div>
              <div style={{fontSize:11,color:"#2e7d32",fontWeight:600}}>{"✓ "+f.receivedDate}</div>
            </div>}
          </div>
          <div style={{textAlign:"right"}}>
            {f.proposalRef&&<div>
              <div style={S.specLabel}>Proposal</div>
              <div style={{fontSize:11}}>{f.proposalRef}</div>
            </div>}
            {f.poNumber&&<div style={{marginTop:4}}>
              <div style={S.specLabel}>PO</div>
              <div style={{fontSize:11}}>{f.poNumber}</div>
            </div>}
          </div>
        </div>
      </div>}
    </div>

    <div style={S.footer}>
      <div style={{fontSize:9,color:"#999",letterSpacing:1,textTransform:"uppercase"}}>Cimon Starr LLC</div>
      {isClient?
        <div style={{fontSize:9,color:"#999"}}>Confidential</div>:
        <div style={{fontSize:9,color:"#999"}}>{new Date().toLocaleDateString()}</div>}
    </div>
  </div>;
}
